import styled from 'styled-components'
import { Col, Row } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'

export const Container = styled.div`
  background: ${variables.colors.white};
  padding: 4rem 0;
  text-align: center;
`

export const SubContainer = styled.div`
  margin: 0 auto;
  max-width: ${variables.maxContentWidth}px;
  padding: 0 2rem;
`

export const CenteredRow = styled(Row)`
  justify-content: center;
  align-items: stretch;
  
  @media ${variables.media.md} {
    justify-content: ${props => props.featuredLayout ? 'center' : 'center'};
  }
`

export const BlockHeader = styled.h2`
  color: ${variables.colors.greyDark};
  font-family: ${variables.fonts.header};
  font-size: ${variables.headerScale.h2Scale}rem;
  text-align: center;
  margin-bottom: 3rem;
  
  @media ${variables.media.sm} {
    font-size: ${variables.headerScale.h2Scale * variables.headerScale.smallScreenHeaderScaleFactor}rem;
  }
`

export const ItemCol = styled(Col)`
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  
  ${props => props.featured && `
    @media ${variables.media.md} {
      padding-right: 1rem;
    }
  `}
`

export const SolutionCard = styled.div`
  background: ${props => props.featured ? variables.colors.oracle.lightest : variables.colors.white};
  border: ${props => props.featured ? `3px solid ${variables.colors.primary}` : `1px solid ${variables.colors.greyLight}`};
  border-radius: 16px;
  padding: 2.5rem 2rem;
  height: 100%;
  width: 100%;
  max-width: ${props => props.featured ? '400px' : '350px'};
  margin: 0 auto;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  
  ${props => props.featured && `
    box-shadow: 0 12px 40px rgba(0,0,0,0.08);
    transform: scale(1.02);
  `}
  
  &:hover {
    transform: ${props => props.featured ? 'scale(1.05)' : 'translateY(-8px)'};
    box-shadow: 0 20px 50px rgba(0,0,0,0.12);
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const IconWrapper = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.featured ? '80px' : '70px'};
  height: ${props => props.featured ? '80px' : '70px'};
  background: ${props => props.featured ? variables.colors.primary : variables.colors.greyLight};
  border-radius: 50%;
  margin: 0 auto 1.5rem auto;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.1);
    background: ${variables.colors.primary};
  }
`

export const Icon = styled.img`
  width: ${props => props.featured ? '40px' : '35px'};
  height: ${props => props.featured ? '40px' : '35px'};
  transition: all 0.3s ease;
`

export const CardHeader = styled.h3`
  color: ${variables.colors.greyDarkest};
  font-family: ${variables.fonts.header};
  font-size: ${props => props.featured ? '1.8rem' : '1.5rem'};
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 700;
`

export const CardText = styled.div`
  color: ${variables.colors.greyDark};
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 1.5rem;
  flex-grow: 1;
`

export const UseCasesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
  background: ${variables.colors.white};
  border-radius: 8px;
  padding: 1rem;
`

export const UseCaseItem = styled.li`
  color: ${variables.colors.greyDark};
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const LearnMoreText = styled.div`
  color: ${props => props.featured ? variables.colors.primary : variables.colors.greyDark};
  font-weight: 600;
  text-align: center;
  margin-top: auto;
  font-size: ${props => props.featured ? '1.1rem' : '1rem'};
  
  &:hover {
    color: ${variables.colors.primary};
  }
`

export const CustomerLogosSection = styled.div`
  margin: 1.5rem 0 1rem 0;
  text-align: center;
`

export const CustomerLogosLabel = styled.div`
  color: ${variables.colors.greyDark};
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const CustomerLogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`

export const CustomerLogo = styled.div`
  img {
    height: 24px;
    max-width: 80px;
    object-fit: contain;
    opacity: 0.7;
    filter: grayscale(100%);
    transition: all 0.3s ease;
    
    &:hover {
      opacity: 1;
      filter: grayscale(0%);
    }
  }
`

export const DemoImageContainer = styled.div`
  margin: 20px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`

export const DemoImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
  }
`